import { render, staticRenderFns } from "./TJsonTextArea.vue?vue&type=template&id=13113094&scoped=true&"
import script from "./TJsonTextArea.vue?vue&type=script&lang=js&"
export * from "./TJsonTextArea.vue?vue&type=script&lang=js&"
import style0 from "./TJsonTextArea.vue?vue&type=style&index=0&id=13113094&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13113094",
  null
  
)

/* custom blocks */
import block0 from "./TJsonTextArea.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports